import { render } from "./CouponPromotion.vue?vue&type=template&id=371584a4"
import script from "./CouponPromotion.vue?vue&type=script&lang=js"
export * from "./CouponPromotion.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__